<template>
  <div>

    <v-dialog persistent v-if="dialogyetki" v-model="dialogyetki" max-width="900px">
      <v-card color="grey lighten-5">

        <v-flex pa-1 xs12 sm12 md12>
          <v-layout row wrap>
            <v-flex pr-3 pt-3 xs12 sm12>
              <div class="scrollbar" id="style-1">
                <v-card color="white" flat>
                  <v-flex pl-3 pr-3 pt-3 xs12 sm12>

                    <div class="force-overflow">
                      <p><strong>Gizlilik Politikası</strong></p>

                      <p>İşbu Gizlilik Politikası’nın amacı,&nbsp;ARKMAN&nbsp;tarafından işletilmekte olan&nbsp;
                      <a href="http://www.arkman.com.tr">http://www.arkman.com.tr</a> internet sitesi (“<strong>Site</strong>”) ile mobil uygulamasının (hepsi ARKMAN “<strong>Platform</strong>” olarak anılacaktır) işletilmesi sırasında Platform kullanıcıları/üyeleri/ziyaretçileri (“<strong>Veri Sahibi</strong>”) tarafından ARKMAN ile paylaşılan veya ARKMAN’un, Veri Sahibi’nin Platform’u kullanımı sırasında ürettiği kişisel verilerin kullanımına ilişkin koşul ve şartları tespit etmektir. &nbsp; &nbsp;&nbsp;</p>

                      <p><strong>Veri Sahibi, işbu Gizlilik Politikası ile kişisel verilerinin işlenmesine ilişkin olarak aydınlatılmış olduğunu ve kişisel verilerinin burada belirtilen şekilde kullanımına muvafakat ettiğini beyan eder. &nbsp;</strong></p>

                      <p><strong>Hangi Veriler İşlenmektedir?&nbsp;</strong></p>
                      <p>İşbu başlık altında, ARKMAN tarafından işlenen ve Kişisel Verilerin Korunması Kanunu uyarınca 
                        kişisel veri sayılan verilerin hangileri olduğu sıralanmıştır. Aksi açıkça belirtilmedikçe, 
                        işbu Gizlilik Politikası kapsamında arz edilen hüküm ve koşullar kapsamında 
                        “<strong>kişisel veri</strong>” ifadesi aşağıda yer alan bilgileri kapsayacaktır. &nbsp;</p>
                      <ul>
                        <li><em>Kimlik Bilgisi&nbsp;</em></li>
                        <li><em>İletişim Bilgisi&nbsp;</em></li>
                        <li><em>Kullanıcı Bilgisi&nbsp;</em></li>
                        <li><em>Kullanıcı İşlem Bilgisi</em></li>
                        <li><em>İşlem Güvenliği Bilgisi</em></li>
                        <li><em>Finansal Bilgi</em></li>
                        <li><em>Hukuki İşlem ve Uyum Bilgisi</em></li>
                        <li><em>Talep/Şikayet Yönetimi Bilgisi</em></li>
                        <li><em>Pazarlama Bilgisi</em></li>
                      </ul>

                      <p>Kişisel Verilerin Korunması Kanunu’nun 3. ve 7. maddeleri dairesince, geri döndürülemeyecek şekilde anonim hale getirilen veriler, anılan kanun hükümleri uyarınca kişisel veri olarak kabul edilmeyecek ve bu verilere ilişkin işleme faaliyetleri işbu Gizlilik Politikası hükümleri ile bağlı olmaksızın gerçekleştirecektir.&nbsp;</p>

                      <p><strong>Hangi Amaçlarla Veriler Kullanılmaktadır?&nbsp;</strong></p>
                      <p>ARKMAN, Veri Sahibi tarafından sağlanan kişisel verileri,&nbsp;<strong>ARKMAN tarafından sunulan hizmetlerin ilgili kişilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için gerekli olan aktivitelerin planlanması ve icrası, ARKMAN tarafından sunulan hizmetlerden ilgili kişileri faydalandırmak için gerekli çalışmaların iş birimleri tarafından yapılması ve ilgili iş süreçlerinin yürütülmesi, ARKMAN’in iş stratejilerinin planlanması ve icrası&nbsp;</strong><strong>amaçlarıyla işlenebilecektir.</strong></p>

                      <p>ARKMAN, Kişisel Verilerin Korunması Kanunu’nun 5 ve 8. maddeleri uyarınca ve/veya ilgili mevzuattaki istisnaların varlığı halinde kişisel verileri Veri Sahibi’nin ayrıca rızasını almaksızın işleyebilecek ve üçüncü kişilerle paylaşabilecektir. Bu durumların başlıcaları aşağıda belirtilmiştir:</p>
                      <ul>
                        <li>Kanunlarda açıkça öngörülmesi,</li>
                        <li>Fiili imkânsızlık nedeniyle rızasını açıklayamayacak durumda bulunan veya rızasına hukuki geçerlilik tanınmayan kişinin kendisinin ya da bir başkasının hayatı veya beden bütünlüğünün korunması için zorunlu olması,</li>
                        <li>Veri Sahibi ile ARKMAN arasında herhangi bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, kişisel verilerin işlenmesinin gerekli olması,</li>
                        <li>ARKMAN’ın hukuki yükümlülüklerini yerine getirebilmesi için zorunlu olması,</li>
                        <li>Veri Sahibi’nin kendisi tarafından alenileştirilmiş olması,</li>
                        <li>Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,&nbsp;</li>
                        <li>Veri Sahibi’nin temel hak ve özgürlüklerine zarar vermemek kaydıyla, ARKMAN’ın meşru menfaatleri için&nbsp;veri işlenmesinin zorunlu olması.&nbsp;</li>
                      </ul>

                      <p><strong>Kimler Verilere Erişebilmektedir?&nbsp;</strong></p>
                      <p>ARKMAN, Veri Sahibi’ne ait kişisel verileri ve bu kişisel verileri kullanılarak elde ettiği yeni verileri, işbu Gizlilik Politikası ile belirlenen amaçların gerçekleştirilebilmesi için ARKMAN’ın hizmetlerinden faydalandığı üçüncü kişilere, söz konusu hizmetlerin temini amacıyla sınırlı olmak üzere aktarılabilecektir. ARKMAN ayrıca, işbu Gizlilik Politikası’nda belirtilen amaçlar dahilinde verileri&nbsp;ARKMAN’ın iş ortakları ve tedarikçileri ile hukuken yetkili kurum ve kuruluşlara&nbsp;aktarabilecektir.</p>

                      <p>ARKMAN, Veri Sahibi deneyiminin geliştirilmesi (iyileştirme ve kişiselleştirme dâhil), Veri Sahibi’nin güvenliğini sağlamak, hileli ya da izinsiz kullanımları tespit etmek, operasyonel değerlendirme araştırılması, Platform hizmetlerine ilişkin hataların giderilmesi ve işbu Gizlilik Politikası’nda yer alan amaçlardan herhangi birisini gerçekleştirebilmek için SMS gönderimi yapanlar da dahil olmak üzere dış kaynak hizmet sağlayıcıları, barındırma hizmet sağlayıcıları (<em>hosting&nbsp;</em>servisleri<em>)</em>, hukuk büroları, araştırma şirketleri, çağrı merkezleri gibi üçüncü kişiler ile paylaşabilecektir.</p>

                      <p>Veri Sahibi, yukarıda belirtilen amaçlarla sınırlı olmak kaydı ile bahsi geçen üçüncü tarafların Veri Sahibi’nin kişisel verilerini dünyanın her yerindeki sunucularında saklayabileceğini, bu hususa peşinen muvafakat ettiğini kabul eder.&nbsp;</p>

                      <p><strong>Verilere Erişim Hakkı ve Düzeltme Talepleri Hakkında</strong></p>
                      <p>Kanun’un 11. maddesi uyarınca veri sahipleri,&nbsp;</p>
                      <ul>
                        <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                        <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                        <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                        <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                        <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                        <li>Kanun&nbsp;ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,&nbsp;</li>
                        <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
                        <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme&nbsp;</li>
                      </ul>
                      <p>haklarına sahiptir.&nbsp;</p>

                      <p>Söz konusu haklar, kişisel veri sahipleri tarafından[________] adresinde yer alan&nbsp;ARKMAN İnşaat Malzemeleri ve Ev Gereçleri Limited ŞirketiKişisel Verilerin <strong>Korunması ve İşlenmesi&nbsp;</strong><strong>Politikası’nda</strong> belirtilen yöntemlerle iletilmesi halinde 30 (otuz) gün içerisinde değerlendirilerek sonuçlandırılacaktır. Taleplere ilişkin olarak herhangi bir ücret talep edilmemesi esas olmakla ARKMAN’ta, ARKMAN’unKişisel Verileri Koruma Kurulu tarafından belirlenen ücret tarifesi üzerinden ücret talep etme hakkı saklıdır.&nbsp;</p>

                      <p>Veri Sahibi, işbu Gizlilik Politikası’na konu bilgilerinin tam, doğru ve güncel olduğunu, bu bilgilerde herhangi bir değişiklik olması halinde bunları derhal güncelleyeceğini taahhüt eder. Veri Sahibi’nin güncel bilgileri sağlamamış olması halinde ARKMAN’un herhangi bir sorumluluğu olmayacaktır.</p>

                      <p>Veri Sahibi, herhangi bir kişisel verisinin ARKMAN tarafından kullanılamaması ile sonuçlanacak bir talepte bulunması halinde Platform’un işleyişinden tam olarak faydalanamayabileceğini kabul ile bu kapsamda doğacak her türlü sorumluluğun kendisine ait olacağını beyan eder. &nbsp;</p>

                      <p><strong>Kişisel Verilerin Saklanma Süresi</strong></p>
                      <p>ARKMAN, Veri Sahibi tarafından sağlanan kişisel verileri, yukarıda belirtilen işleme amaçlarının gerektirdiği süre boyunca saklayacaktır.&nbsp;</p>

                      <p>Buna ek olarak, ARKMAN, Veri Sahibi ile arasında doğabilecek herhangi bir uyuşmazlık durumunda, uyuşmazlık kapsamında gerekli savunmaların gerçekleştirilebilmesi amacıyla sınırlı olmak üzere ve ilgili mevzuat uyarınca belirlenen zamanaşımı süreleri boyunca kişisel verileri saklayabilecektir.&nbsp;</p>

                      <p><strong>Veri Güvenliğine İlişkin Önlemler ve Taahhütler</strong></p>
                      <p>ARKMAN, ilgili mevzuatta belirlenen veya işbu Gizlilik Politikası’nda ifade edilen şartlarda,&nbsp;</p>
                      <ul>
                        <li>kişisel verilerin hukuka aykırı olarak işlenmemesini,</li>
                        <li>kişisel verilere hukuka aykırı olarak erişilmemesini ve</li>
                        <li>kişisel verilerin muhafazasını&nbsp;</li>
                      </ul>
                      <p>sağlamak amacıyla uygun güvenlik düzeyini temin etmeye yönelik gerekli teknik ve idari tedbirleri almayı, gerekli denetimleri yaptırmayı taahhüt eder.&nbsp;</p>

                      <p>ARKMAN, Veri Sahibi hakkında elde ettiği kişisel verileri işbu Gizlilik Politikası ve Kişisel Verilerin Korunması Kanunu hükümlerine aykırı olarak başkasına açıklayamaz ve işleme amacı dışında kullanamaz.&nbsp;</p>

                      <p>Platform üzerinden başka uygulamalara link verilmesi halinde, ARKMAN uygulamaların gizlilik politikaları ve içeriklerine yönelik herhangi bir sorumluluk taşımamaktadır.</p>

                      <p><strong>Çerezler (Cookie’ler)</strong></p>
                      <p>Veri Sahipleri’nin Platform’dan en verimli şekilde faydalanabilmesi ve kullanıcı deneyiminin geliştirilmesi için Platform’da Cookie kullanılmaktadır. Cookie kullanılmasını tercih etmezseniz tarayıcınızın ayarlarından Cookie’leri silebilir ya da engelleyebilirsiniz. Ancak Platform’u kullanımınızı etkileyebileceğini hatırlatmak isteriz. Tarayıcınızdan Cookie ayarlarınızı değiştirmediğiniz sürece bu Platform’da çerez kullanımını kabul ettiğinizi varsayacağız.&nbsp;</p>

                      <ul>
                        <li><strong><u>Çerez Nedir ve Neden Kullanılmaktadır?</u></strong></li>
                      </ul>
                      <p>Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarıdır. Çerezler konusundan daha detaylı bilgi için:&nbsp;
                        <a href="http://www.aboutcookies.org/">http://www.aboutcookies.org/</a>ve&nbsp;
                        <a href="http://www.allaboutcookies.org/">http://www.allaboutcookies.org/</a>adreslerini ziyaret edebilirisiniz.&nbsp;
                      </p>
                      <p>İnternet Sitemizde çerez kullanılmasının başlıca amaçları aşağıda sıralanmaktadır:&nbsp;</p>
                      <ul>
                        <li>İnternet sitesinin işlevselliğini ve performansını arttırmak yoluyla sizlere sunulan hizmetleri geliştirmek,</li>
                        <li>İnternet Sitesini iyileştirmek ve İnternet Sitesi üzerinden yeni özellikler sunmak ve sunulan özellikleri sizlerin tercihlerine göre kişiselleştirmek;</li>
                        <li>İnternet Sitesinin, sizin ve ARKMAN’un hukuki ve ticari güvenliğinin teminini sağlamak.</li>
                      </ul>

                      <ul>
                        <li><strong><u>Çerezlerin Kullanımı Veri Sahipleri Tarafından Engellenebilir mi?</u></strong></li>
                      </ul>

                      <p>Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkanına sahipsiniz.&nbsp;</p>

<table border="1" cellpadding="0" cellspacing="0" width="100%">
  <tbody>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Adobe Analytics</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="http://www.adobe.com/uk/privacy/opt-out.html">http://www.adobe.com/uk/privacy/opt-out.html</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>AOL</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser">https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Google Adwords&nbsp;</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="https://support.google.com/ads/answer/2662922?hl=en">https://support.google.com/ads/answer/2662922?hl=en</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Google Analytics</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Google Chrome</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="http://www.google.com/support/chrome/bin/answer.py?hl=en&amp;answer=95647">http://www.google.com/support/chrome/bin/answer.py?hl=en&amp;answer=95647</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Internet Explorer</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>MozillaFirefox</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="http://support.mozilla.com/en-US/kb/Cookies">http://support.mozilla.com/en-US/kb/Cookies</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Opera</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="http://www.opera.com/browser/tutorials/security/privacy/">http://www.opera.com/browser/tutorials/security/privacy/</a>
        </p>
      </td>
    </tr>
    <tr>
      <td valign="top" width="19.19191919191919%">
        <p>Safari:</p>
      </td>
      <td valign="top" width="80.8080808080808%">
        <p>
          <a href="https://support.apple.com/kb/ph19214?locale=tr_TR">https://support.apple.com/kb/ph19214?locale=tr_TR</a>
        </p>
      </td>
    </tr>
  </tbody>
</table>

                      <p><strong>Gizlilik Politikası’ndaki Değişiklikler</strong></p>
                      <p>ARKMAN, işbu Gizlilik Politikası hükümlerini dilediği zaman değiştirebilir. Güncel Gizlilik Politikası, Veri Sahibi’ne herhangi bir yöntemle sunulduğu tarihte yürürlük kazanır.</p>

                    </div>

                  </v-flex>
                </v-card>
              </div>
            </v-flex>

          </v-layout>

        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click="sozlesmeIptal()">{{ $t('OK') }}</v-btn>

          <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      sozlesmeKabul() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramssozlesme = {
          ID: null,
          SozlesmeID: this.mesaj.SozlesmeID,
          UserID: credentials.UserID,
          ConfirmDate: helpers.getDateTimeNow(),
        }

        this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractConfirm', paramssozlesme, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            'CariSirketNo': credentials.SirketKodu.toString(),
            'CoperSirketNo': credentials.CoperSirketNo.toString(),
            'MusteriKodu': credentials.AnaSirketKodu.toString()
          }
        }).then((response) => {

          if (response.body.Status == true) {
            this.resolve(true);
            this.dialogyetki = false

          } else {

          }

           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true

        }, (response) => {
          this.text1 = 'Service Unavailable'
          this.snackbar = true


        })
      },
      sozlesmeIptal() {
        this.resolve(false);
        this.dialogyetki = false
      },


      open(mesaj) {
       //this.mesaj = mesaj
       // this.mesaj.SozlesmeText = this.mesaj.SozlesmeText

        this.dialogyetki = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        bekle: false,
        islem: 0,
        sozlesmeOnay: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialogyetki: false,
        k: null,
        doviztipi: [],
        reject: null,
        tahsilatdialog: false,
        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>
<style>
  header {
    font-family: 'Lobster', cursive;
    text-align: center;
    font-size: 25px;
  }

  #info {
    font-size: 18px;
    color: #555;
    text-align: center;
    margin-bottom: 25px;
  }

  a {
    color: #074E8C;
  }

  .scrollbar {
    margin-left: 10px;
    float: left;
    height: 300px;
    width: 100%px;
    background: rgb(255, 255, 255);
    overflow-y: scroll;
    margin-bottom: 25px;
  }

  .force-overflow {
    min-width: 800px;
  }

  #wrapper {
    text-align: center;
    width: 500px;
    margin: auto;
  }

  /*
 *  STYLE 1
 */

  #style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: royalblue;
  }
</style>